export default __webpack_public_path__ + "static/media/Helm of Flowing Water.82dc7303.jpg";